'use client';

import { SignIn } from '@clerk/nextjs';

export function SignInClient({ redirectUrl }: { redirectUrl: string }) {
	return (
		<SignIn fallbackRedirectUrl={redirectUrl} forceRedirectUrl={redirectUrl} signUpForceRedirectUrl={redirectUrl} />
	);
}
